import * as Application from 'expo-application'
import Constants from 'expo-constants'
import { Platform } from 'react-native'

export const appVersion =
  Platform.select({
    ios: Application.nativeApplicationVersion,
    web: Constants.expoConfig?.version,
    android: Application.nativeApplicationVersion,
  }) ?? undefined
